import { User, UserRoles } from "../../stores/AuthStore/types";

const profileFormRules = {
  email: {
    required: true,
    pattern:
      /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/,
  },
  phone: {
    required: true,
    pattern: /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
  },
  firstName: {
    required: true,
    maxLength: 50,
    pattern: /[A-Za-zÖöÇçĞğİıŞşÜü]/,
  },
  lastName: {
    required: true,
    maxLength: 50,
    pattern: /[A-Za-zÖöÇçĞğİıŞşÜü]/,
  },
  roles: {
    required: true,
    validate: (value: UserRoles[] | undefined, formValues: User) => {
      console.log(formValues.barName, formValues.barNo);
      return (
        (value?.includes(UserRoles.LAWYER) &&
          !!formValues.barName &&
          !!formValues.barNo) ||
        (!value?.includes(UserRoles.LAWYER) && !!value && value.length > 0)
      );
    },
  },
  barNo: {
    required: false,
    minLength: 5,
    maxLength: 5,
    pattern: /[0-9]/,
    deps: ["barName" as keyof User],
    validate: (value: number | undefined, formValues: User) =>
      (!value && !formValues.barName) || !!formValues.barName,
  },
  barName: {
    required: false,
    deps: ["barNo" as keyof User],
    validate: (value: string | undefined, formValues: User) =>
      (!value && !formValues.barNo) || !!formValues.barNo,
  },
};

export default profileFormRules;
